import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full overflow-hidden text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-4xl" }
const _hoisted_6 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_7 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_8 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onSubmit"]
const _hoisted_12 = { class: "mt-4 space-y-2" }
const _hoisted_13 = ["value", "checked", "onChange"]
const _hoisted_14 = {
  class: "inline-block pl-[0.15rem] capitalize",
  for: "checkboxDefault"
}
const _hoisted_15 = { class: "flex justify-center px-4 py-3 bg-gray-50" }

import { ref } from "vue";

import DefaultButton from "../DefaultButton.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { EmailList } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectMarketingPreferencesModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
},
  emits: ["close", "select"],
  async setup(__props, { emit: emits }) {

let __temp: any, __restore: any

const props = __props;

const globalStore = useGlobalStore();
const userStore = useUserStore();




const url = `${process.env.VUE_APP_WEBSITE_URL}/privacy-policy/`;

const lists = ref([] as EmailList[]);
const userLists = ref([] as string[]);

const selectedValues = ref([] as number[]);
const unselectedValues = ref([] as number[]);

function close() {
  emits("close");
}

function addToValues(id: number) {
  if (selectedValues.value.includes(id)) {
    selectedValues.value = selectedValues.value.filter(value => value !== id);

    if (!unselectedValues.value.includes(id)) {
      unselectedValues.value.push(id);
    }
  } else {
    selectedValues.value.push(id);
  }
}

async function saveMarketingPreferences() {
  try {
    const response = await api.brevo.setMarketingPreferences(selectedValues.value, unselectedValues.value);

    if (response.meta.status === 200) {
      userStore.user.has_completed_marketing_material = true;
      globalStore.toast("SUCCESS", response.data.message);
    }
  } catch (error) {
    console.error(error);
    globalStore.toast("ERROR", "Issue updating marketing preferences, please contact Play Included.");
  } finally {
    close();
  }
}

lists.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.brevo.listEmailLists())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.lists;
userLists.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.brevo.getContactInfo())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.lists;
selectedValues.value = userLists.value.map(list => Number(list));

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t("select-marketing-preferences")), 1)
                ]),
                _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                  _createElementVNode("button", { onClick: close }, _hoisted_10)
                ])
              ]),
              _createElementVNode("form", {
                class: "px-4 pb-8 mt-4 border-b border-gray-400",
                onSubmit: _withModifiers(saveMarketingPreferences, ["prevent"])
              }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("marketing-preferences-copy-1")), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("i-would-like-to-receive-emails-from")), 1),
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (list, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "block space-x-2",
                        key: index
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: "required_role_input",
                          value: list,
                          class: "rounded hover:cursor-pointer",
                          checked: selectedValues.value.includes(list.brevo_id),
                          onChange: ($event: any) => (addToValues(list.brevo_id))
                        }, null, 40, _hoisted_13),
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t(list.name)), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_i18n_t, {
                    keypath: "marketing-preferences-copy-2",
                    tag: "label",
                    for: "privacy-policy"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: url,
                        target: "_blank",
                        class: "text-blue-500 underline"
                      }, _toDisplayString(_ctx.$t("privacy-policy")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(DefaultButton, {
                    type: "primary",
                    "is-form-submit": true,
                    disabled: false
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
                    ]),
                    _: 1
                  })
                ])
              ], 40, _hoisted_11)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})